/**
 * Generate a uniqid
 * 
 * @return {string}
 */
export function uniqid(): string {
    const sec = (Date.now() * 1000) + (Math.random() * 1000);
    const id = sec.toString(16).replace(/\./g, '').padEnd(14, '0');

    return id + Math.trunc(Math.random() * 100000000);
}

/**
 * Supprime les accents d'une chaîne de caractères
 * 
 * @param {string} str
 * 
 * @return {string}
 */
export function removeAccents(str: string): string {
    return str
        .normalize('NFD') // Convertit les caractères spéciaux en unicode (è => `e)
        .replace(/[\u0300-\u036f]/g, ''); // Retire les caractères spéciaux (`e => e)
}
